import { render, staticRenderFns } from "./processing-requests-list.view.vue?vue&type=template&id=d9a9b830&"
import script from "./processing-requests-list.view.vue?vue&type=script&lang=ts&"
export * from "./processing-requests-list.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports